import { connect } from 'react-redux';
import { branch, compose, renderComponent, renderNothing, lifecycle } from 'recompose';
import { push } from 'react-router-redux';

export const createRedirectComponent = (path) => {
  return compose(
    connect(null, { push }),
    lifecycle({
      componentDidMount() {
        this.props.push(path);
      }
    })
  )(() => null);
};

const RedirectToDashboard = createRedirectComponent('/product');
const RedirectToLogin = createRedirectComponent('/login');

export const redirectIfLoggedIn = compose(
  connect((state) => ({ loggedIn: state.auth.loggedIn, isCheckedLogin: state.auth.isCheckedLogin })),
  branch(
    ({ isCheckedLogin }) => !isCheckedLogin,
    renderNothing,
  ),
  branch(({ loggedIn }) => loggedIn, renderComponent(RedirectToDashboard))
);

export const redirectIfNotLoggedIn = compose(
  connect((state) => ({ loggedIn: state.auth.loggedIn, isCheckedLogin: state.auth.isCheckedLogin })),
  branch(
    ({ isCheckedLogin }) => !isCheckedLogin,
    renderNothing,
  ),
  branch(({ loggedIn }) => !loggedIn, renderComponent(RedirectToLogin))
);



// WEBPACK FOOTER //
// ./src/utils/HOCs/redirect.js